import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CollapsibleSection',
  setup(__props) {

const is_open = ref(false);

function toggle_is_open() {
  is_open.value = !is_open.value;
}

return { __sfc: true,is_open, toggle_is_open }
}

})